'use client';

import { useEffect } from 'react';

/**
 * GDPR Flag Component
 * Sets window.GDPR = true in the head before GTM loads
 * This is required for Cookie Consent Manager integration
 * 
 * According to IT-Cookie Consent Manager documentation:
 * "Systems integrating CCM should ensure that 'window.GDPR= true;' is set in the head."
 */
export function GdprFlag() {
  useEffect(() => {
    // Set GDPR flag immediately when component mounts
    // This ensures it's available when GTM loads
    if (typeof window !== 'undefined') {
      (window as any).GDPR = true;
    }
  }, []);

  // Also set it synchronously before React hydration
  if (typeof window !== 'undefined' && !(window as any).GDPR) {
    (window as any).GDPR = true;
  }

  return null;
}

